import { AppState } from 'app/store';

export const getSharedLinksLink = (state: AppState) =>
  state.auth.services?.shares?._links.listShares;

export const getSharedAudioLinks = (state: AppState, audioGuid: string) =>
  state.shares.sharedAudioLinks[audioGuid];

export const getSharedLinkListNextLink = (state: AppState) =>
  state.shares._links?.next;

export const getCreateShareLink = (state: AppState) =>
  state.shares._links?.createShare;

export const getDownloadList = (state: AppState) => state.shares.downloadList;

export const getSharedPlaylist = (state: AppState) =>
  state.shares.sharedPlaylist;

export const getSharedAudioPlayAudioLink = (state: AppState) =>
  state.shares.sharedPlaylist?._links?.playAudio;

export const getDesktopWaveformLink = (state: AppState) =>
  state.shares.sharedPlaylist?._links?.getDesktopWaveform;

export const getSharedAudioDownloadLink = (state: AppState) =>
  state.shares.sharedPlaylist?._links?.downloadAudio;

export const getSharedAudioContributionsLink = (state: AppState) =>
  state.shares.sharedPlaylist?._links?.contributions;

export const getSharedAudioLyricsLink = (state: AppState) =>
  state.shares.sharedPlaylist?._links?.lyrics;

export const getSharedPlaylistLinks = (state: AppState, playlistGuid: string) =>
  state.shares.sharedPlaylistLinks[playlistGuid];

export const getSharePlaylistGuid = (state: AppState) =>
  getSharedPlaylist(state)?.guid;

export const isAudioShareModalOpen = (state: AppState) =>
  state.shares.shareModal.isOpen && state.shares.shareModal?.type === 'audio';

export const isPlaylistShareModalOpen = (state: AppState) =>
  state.shares.shareModal.isOpen &&
  state.shares.shareModal?.type === 'playlist';
